/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import { Event } from '@mirai/data-sources';
import { InputOption, ScrollView, Text, useDevice, View } from '@mirai/ui';
import React, { useEffect, useState } from 'react';

import { TESTIMONIALS } from './Home.constants';
import * as style from './routes.module.css';

const EVENT_INTENT_ENVIRONMENT = 'intentEnvironment';

export const Home = () => {
  const { isMobile } = useDevice();

  const [locale, setLocale] = useState();
  const [resident, setResident] = useState();

  useEffect(() => {
    const handleIntentEnvironment = ({ locale: value } = {}) => setLocale(value);

    Event.subscribe(EVENT_INTENT_ENVIRONMENT, handleIntentEnvironment);

    return () => Event.unsubscribe(EVENT_INTENT_ENVIRONMENT, handleIntentEnvironment);
  }, []);

  useEffect(() => {
    Event.publish('setStore', { promocode: resident ? 'RESIDENT' : '' });
  }, [resident]);

  const showResident = locale === 'es-ES';
  const testId = window.IS_PLAYWRIGHT ? 'finder' : undefined;

  return (
    <>
      <View tag="section" className={[style.section, style.content, style.home]}>
        <View className={[style.wrapper, style.centered]}>
          <Text bold brand className={[style.slogan, style.text]}>
            Discover the Serenity of a Perfect Stay
          </Text>
          <Text className={[style.pitch, style.text]}>
            Experience the calming atmosphere of our serene guest rooms, each designed with your comfort in mind.
          </Text>
        </View>
        <View className={style.backgroundImage} />
      </View>

      <View className={[style.finder, style.centered, showResident && style.resident]}>
        {showResident && (
          <View>
            <InputOption
              checked={resident}
              name="resident"
              label="I am resident"
              onChange={setResident}
              className={style.resident}
            />
          </View>
        )}

        <View data-mirai-component="finder" data-test-id={testId} />
      </View>

      <View row={!isMobile} tag="section" className={[style.section, style.spaceBetween, style.wrapper]}>
        <View className={style.texts}>
          <Text brand headline level={1}>
            Welcome to Monalisa
          </Text>

          <Text lighten>
            Welcome to Monalisa, where Monalisa and convenience converge in the heart of the city. Our hotel is located
            in the bustling city center, just steps away from the best shopping, dining, and entertainment that the city
            has to offer.
          </Text>
          <Text lighten>
            One of our greatest strengths is our location. We are situated in the middle of the city center, which means
            that our guests can easily explore all the sights and sounds of this vibrant metropolis. Plus, we are just a
            stone's throw away from the train station, making it incredibly easy for our guests to arrive and depart
            from our hotel.
          </Text>
          <Text lighten>
            So why wait? Book your stay at Monalisa today and experience the perfect blend of Monalisa, convenience, and
            comfort in the heart of the city.
          </Text>
        </View>
      </View>

      <View row={!isMobile} tag="section" className={[style.section, style.accent, style.testimonials]}>
        <View>
          <Text brand headline level={1}>
            Testimonials
          </Text>
          <Text>See what our guests are saying about their serene and tranquil experiences at Monalisa.</Text>
        </View>

        <ScrollView horizontal snap={!isMobile} className={style.cards}>
          {TESTIMONIALS.map(({ text, rating, name, jobPosition } = {}, index) => (
            <View key={index} className={style.card}>
              <Text action>{text}</Text>
              <Text accent action>
                {'★'.repeat(rating)}
              </Text>

              <View row>
                <View
                  className={style.avatar}
                  style={{ backgroundImage: `url(https://i.pravatar.cc/96?u=${index})` }}
                />
                <View>
                  <Text action>{name}</Text>
                  <Text lighten small>
                    {jobPosition}
                  </Text>
                </View>
              </View>
            </View>
          ))}
        </ScrollView>
      </View>

      {!window.IS_PLAYWRIGHT && (
        <View row={!isMobile} tag="section" className={[style.section, style.wrapper]}>
          <View data-mirai-component="finder" data-layout="expand" />
        </View>
      )}

      <View row tag="section" className={[style.section, style.border, style.centered]}>
        <View>
          <Text>FIND BEST HOTEL FOR LEAVING</Text>
          <Text bold brand headline level={1}>
            Find the Best Hotel in Your Next Vacation
          </Text>
        </View>
        <View data-mirai-component="buttonFinder" />
      </View>
    </>
  );
};
